import type { ImageWidget } from "~/types/widgets"

import Image from "~/components/ui/Image"

export interface Props {
  /**
   * @title Banner
   */
  banner: ImageWidget

  /**
   * @title Texto Alternativo do banner
   */
  alt: string

  /**
   * @title Texto SEO - Desktop
   * @format html
   */
  seoDesktop: string

  /**
   * @title Texto SEO - Mobile
   * @format html
   */
  seoMobile: string

  /**
   * @title Cor do texto
   * @format color
   */
  colorText?: string
}

export default function BrandSeoBottom(
  { banner, alt, seoDesktop, seoMobile, colorText, isMobile }: Awaited<
    ReturnType<typeof loader>
  >,
) {
  if (!banner || !alt || !seoDesktop || !seoMobile) return null

  return (
    <div
      id='brand-seo'
      className='w-full max-w-[1834px] flex flex-col lg:flex-row items-center gap-5 lg:gap-14 2xl:gap-20 mt-12 mb-12 lg:mb-24 mx-auto px-4'
    >
      <Image
        src={banner}
        className='w-full h-full object-cover max-w-80 min-w-80 rounded-xl overflow-hidden'
        width={320}
        height={380}
        alt={alt}
      />

      <div
        className='text-sm md:text-base lg:columns-2 lg:gap-x-14 2xl:gap-x-20 lg:overflow-auto'
        style={{ color: colorText }}
        dangerouslySetInnerHTML={{ __html: !isMobile ? seoDesktop : seoMobile }}
      />
    </div>
  )
}

export const loader = (props: Props & { isMobile?: boolean }) => {
  const colorText = props.colorText ?? '#333333'
  const isMobile = props.isMobile ?? false

  return { ...props, colorText, isMobile }
}
